import { render, staticRenderFns } from "./addSchool.vue?vue&type=template&id=904dff22&scoped=true"
import script from "./addSchool.vue?vue&type=script&lang=js"
export * from "./addSchool.vue?vue&type=script&lang=js"
import style0 from "./addSchool.vue?vue&type=style&index=0&id=904dff22&prod&lang=scss&scoped=true"
import style1 from "./addSchool.vue?vue&type=style&index=1&id=904dff22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904dff22",
  null
  
)

export default component.exports